import {
  StructuralCard,
  StructuralItemLayout,
} from '@doltech/ui/lib/figma/Card/DolCard/TextOnlyCard/StructuralCard';
import { useFromScreens } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { MONTH_NAME_FORMAT } from '@doltech/utils/lib/constants';
import { formatDate } from '@doltech/utils/lib/date';
import { getLengthEnumTextByKey } from '@doltech/utils/lib/enum/LengthEnum';
import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import * as React from 'react';

interface Props {
  data: any;
}

export const BlogCard = (props: Props) => {
  const { data } = props;
  const { thumbnail, question, name, page } = data;
  const timeToRead = page?.timeToRead;
  const createdAt = page?.createdAt;

  const cardImage = thumbnail || page?.thumbnail;

  const pageUrl = getLandingUrlFromPath(page?.url, 'landing-blog');
  const title = name || data.title;
  const description = question || data.description;

  const metadata = React.useMemo(
    () => [
      {
        id: 'CREATED_AT',
        text: formatDate(createdAt, MONTH_NAME_FORMAT),
      },
      {
        id: 'TIME_TO_READ',
        text: getLengthEnumTextByKey(timeToRead),
      },
    ],
    [createdAt, timeToRead]
  );
  const [, from776] = useFromScreens([0, 776]);

  const imageProps = React.useMemo(() => {
    if (from776) {
      return {
        ratio: 3 / 2,
        width: 186,
      };
    }
    return {
      ratio: 1,
      width: 58,
    };
  }, [from776]);

  const structuralCardItems: StructuralItemLayout[] = React.useMemo(() => {
    return [
      {
        dataIndex: 'card-main',
        direction: 'horizontal',
        gridTemplate: {
          areas: `"image card-content"`,
          columns: 'max-content 1fr',
          gap: from776 ? [24, 24] : [12, 12],
        },
        items: [
          {
            dataIndex: 'image',
            type: 'IMAGE',
            defaultProps: {
              url: pageUrl,
              imageUrl: cardImage?.url,
              alt: cardImage?.alt || title,
              ...imageProps,
            },
          },
          {
            dataIndex: 'card-content',
            direction: 'vertical',
            gridTemplate: {
              gap: from776 ? [8, 8] : [4, 4],
              areas: `
              "card-header"
              "description"
              `,
            },
            items: [
              {
                dataIndex: 'card-header',
                direction: 'vertical',
                gridTemplate: {
                  gap: [4, 4],
                  areas: `
                  "meta"
                  "title"
                `,
                },
                items: [
                  {
                    dataIndex: 'meta',
                    type: 'META',
                    defaultProps: {
                      metadata,
                    },
                  },
                  {
                    dataIndex: 'title',
                    type: 'TITLE',
                    defaultProps: {
                      children: title,
                      url: pageUrl,
                    },
                  },
                ],
              },

              {
                dataIndex: 'description',
                type: 'DESCRIPTION',
                defaultProps: {
                  children: description,
                },
              },
            ],
          },
        ],
      },
    ];
  }, [from776, description, imageProps, metadata, pageUrl, cardImage?.alt, cardImage?.url, title]);

  return <StructuralCard className="blog-structural-card" items={structuralCardItems} />;
};
